import { Component, Optional } from '@angular/core';
import { AuthService, LoginCredential } from '../auth.service';
import { MatDialogRef } from '@angular/material/dialog';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'member-login',
  standalone: true,
  imports: [RouterLink, FormsModule],
  templateUrl: './member-login.component.html',
  styleUrls: ['./member-login.component.css']
})
export class MemberLoginComponent {

  toggle: boolean = false;

  email: string = '';
  password: string = '';

  constructor(private authService: AuthService, @Optional() private dialogRef: MatDialogRef<MemberLoginComponent>, private router: Router) {
  }


  cancel() {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.router.navigate(['/']);
    }

  }

  openLoginDialog() {
    if (!this.dialogRef) {
      this.router.navigate(['/login']);

    } else {
      this.dialogRef.close(null);
      setTimeout(() => {
        this.authService.openMemberLogin();
      }, 1000);
    }
  }

  toggleView() {
    if (this.toggle) {
      this.toggle = false;
    } else {
      this.toggle = true;
    }
  }

  async login(form: NgForm) {
    if (form.invalid) {
      this.authService.openSnackBar('Checkyour inputs', '');
      return;
    }

    let credential: LoginCredential = {
      email: form.value.email,
      password: form.value.password
    }

    try {
      let authResponse = await this.authService.memberLogin(credential);

      if (authResponse) {

        //this.authService.storeAuthToken(authResponse);
        this.authService.updateAuthState(authResponse);
        this.password = '';
        this.email = '';
        this.authService.openSnackBar('Login succesful', '');
        this.dialogRef.close(authResponse);
        form.reset();

        return
      }

      this.authService.openSnackBar('There was an error login in', 'please try again');

    } catch (err) {
      this.authService.openSnackBar('There was an error login in', 'please try again');
    }
  }
}
